module.exports = __webpack_public_path__ + "static/media/domain_logo_USA.5a8761dd.svg";